<template>
  <div class="live live01">
    <div class="inner">
      <Title>
        <template #title>
          プレゼントキーワード付き企業LIVE
        </template>
      </Title>
      <div class="description">
        <p>
          LIVEに参加して3つキーワードを集めよう！<br>
          キーワードを3つ集めた後は抽選会に応募しよう（締切 15:40）<br>
          ※開催日ごとにキーワードは変わります
        </p>
      </div>
      <!-- <div
        class="comingsoon"
        v-if="month === '202008'"
      >
        <figure>
          <img src="/img/logo.svg">
          <figcaption>
            COMING SOON<br>
            お楽しみに♪
          </figcaption>
        </figure>
      </div>
      <div v-else> -->
        <div class="live-programs"
        v-if="month === '202008'"
        >
          <LiveProgram08
            v-for="program in companyLive"
            :key="program.id"
            :program="program"
            liveType="company"
            :month="month"
          />
        </div>
        <div class="live-programs"
        v-if="month === '202007'"
        >
          <LiveProgram07
            v-for="program in companyLive"
            :key="program.id"
            :program="program"
            liveType="company"
            :month="month"
          />
        </div>
        <div class="live-programs"
        v-if="month === '202006'"
        >
          <LiveProgram06
            v-for="program in companyLive"
            :key="program.id"
            :program="program"
            liveType="company"
            :month="month"
          />
        </div>
        <infinite-loading
          :identifier="infiniteId"
          @infinite="infiniteHandler"
        >
          <div slot="no-more"></div>
          <div slot="no-results"></div>
          <div slot="spinner">
              <Spinner />
            </div>
        </infinite-loading>
      <!-- </div> -->
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import Title from '@/components/atoms/Title.vue'
import LiveProgram06 from '@/components/molecules/202006/LiveProgram.vue'
import LiveProgram07 from '@/components/molecules/202007/LiveProgram.vue'
import LiveProgram08 from '@/components/molecules/202008/LiveProgram.vue'
import InfiniteLoading from 'vue-infinite-loading'
import Spinner from '@/components/atoms/Spinner.vue'

export default {
  props: {
    month: {
      type: String,
      required: true
    }
  },
  components: {
    Title,
    LiveProgram06,
    LiveProgram07,
    LiveProgram08,
    InfiniteLoading,
    Spinner
  },
  data: () => ({
    infiniteId: +new Date(),
    companyLive: []
  }),
  computed: {
    ...mapState([
      'dateTab',
      'lastCompanySnapshots'
    ]),
    ...mapGetters([
      'companyLive0624',
      'companyLive0625',
      'companyLive0728',
      'companyLive0729',
      'companyLive0827',
      'companyLive0828'
    ]),
    companyTitle () {
      alert(this.month)
      return this.month === '202009' ? 'スタンプラリー企業ブース' : 'プレゼントキーワード付き企業LIVE'
    }
  },
  methods: {
    ...mapActions([
      'getCompanyLivePrograms'
    ]),
    async infiniteHandler ($state) {
      await this.getCompanyLivePrograms({
        month: this.month
      })
        .then(() => {
          this.setLive()
          $state.loaded()
        })
        .catch(() => {
          $state.complete()
        })
    },
    setLive () {
      if (this.dateTab === '2020-06-24') {
        this.companyLive = this.companyLive0624
      } else if (this.dateTab === '2020-06-25') {
        this.companyLive = this.companyLive0625
      } else if (this.dateTab === '2020-07-28') {
        this.companyLive = this.companyLive0728
      } else if (this.dateTab === '2020-07-29') {
        this.companyLive = this.companyLive0729
      } else if (this.dateTab === '2020-08-27') {
        this.companyLive = this.companyLive0827
      } else {
        this.companyLive = this.companyLive0828
      }
    }
  },
  watch: {
    dateTab: {
      handler (val, old) {
        this.setLive()
      }
    }
  }
}
</script>

<style lang="sass" scoped>
.live01
  padding: 20px 0 25px
</style>
